"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONListLevelPropertiesConverter = void 0;
var common_1 = require("@devexpress/utils/lib/utils/common");
var list_level_properties_1 = require("../../../numbering-lists/list-level-properties");
var json_list_enums_1 = require("../../enums/json-list-enums");
var JSONListLevelPropertiesConverter = (function () {
    function JSONListLevelPropertiesConverter() {
    }
    JSONListLevelPropertiesConverter.convertFromJSON = function (obj) {
        var result = new list_level_properties_1.ListLevelProperties();
        result.start = obj[json_list_enums_1.JSONListLevelProperty.Start];
        result.format = obj[json_list_enums_1.JSONListLevelProperty.Format];
        result.convertPreviousLevelNumberingToDecimal = !!obj[json_list_enums_1.JSONListLevelProperty.ConvertPreviousLevelNumberingToDecimal];
        result.suppressBulletResize = !!obj[json_list_enums_1.JSONListLevelProperty.SuppressBulletResize];
        result.suppressRestart = !!obj[json_list_enums_1.JSONListLevelProperty.SuppressRestart];
        result.alignment = obj[json_list_enums_1.JSONListLevelProperty.Alignment];
        result.displayFormatString = obj[json_list_enums_1.JSONListLevelProperty.DisplayFormatString];
        result.relativeRestartLevel = obj[json_list_enums_1.JSONListLevelProperty.RelativeRestartLevel];
        result.separator = obj[json_list_enums_1.JSONListLevelProperty.Separator];
        result.templateCode = obj[json_list_enums_1.JSONListLevelProperty.TemplateCode];
        result.originalLeftIndent = obj[json_list_enums_1.JSONListLevelProperty.OriginalLeftIndent];
        result.legacy = !!obj[json_list_enums_1.JSONListLevelProperty.Legacy];
        result.legacySpace = obj[json_list_enums_1.JSONListLevelProperty.LegacySpace];
        result.legacyIndent = obj[json_list_enums_1.JSONListLevelProperty.LegacyIndent];
        return result;
    };
    JSONListLevelPropertiesConverter.convertToJSON = function (source) {
        var result = {};
        result[json_list_enums_1.JSONListLevelProperty.Start] = source.start;
        result[json_list_enums_1.JSONListLevelProperty.Format] = source.format;
        result[json_list_enums_1.JSONListLevelProperty.ConvertPreviousLevelNumberingToDecimal] = common_1.boolToInt(source.convertPreviousLevelNumberingToDecimal);
        result[json_list_enums_1.JSONListLevelProperty.SuppressBulletResize] = common_1.boolToInt(source.suppressBulletResize);
        result[json_list_enums_1.JSONListLevelProperty.SuppressRestart] = common_1.boolToInt(source.suppressRestart);
        result[json_list_enums_1.JSONListLevelProperty.Alignment] = source.alignment;
        result[json_list_enums_1.JSONListLevelProperty.DisplayFormatString] = source.displayFormatString;
        result[json_list_enums_1.JSONListLevelProperty.RelativeRestartLevel] = source.relativeRestartLevel;
        result[json_list_enums_1.JSONListLevelProperty.Separator] = source.separator;
        result[json_list_enums_1.JSONListLevelProperty.TemplateCode] = source.templateCode;
        result[json_list_enums_1.JSONListLevelProperty.OriginalLeftIndent] = source.originalLeftIndent;
        result[json_list_enums_1.JSONListLevelProperty.Legacy] = common_1.boolToInt(source.legacy);
        result[json_list_enums_1.JSONListLevelProperty.LegacySpace] = source.legacySpace;
        result[json_list_enums_1.JSONListLevelProperty.LegacyIndent] = source.legacyIndent;
        return result;
    };
    return JSONListLevelPropertiesConverter;
}());
exports.JSONListLevelPropertiesConverter = JSONListLevelPropertiesConverter;
